import { courts as courtParents } from '../courts'
import { stateFilters } from '../haystack-filters'
import { expandedJurisTypes, expandedMotionTypes } from './enums'

const equalsIgnoreCase = (text: string, valueToCompare: string) =>
  text?.toUpperCase() === valueToCompare?.toUpperCase()

export const expandJurisTypes = (values: string[] = []) =>
  values.flatMap((type) => expandedJurisTypes[type.toLowerCase()] || [])

export const expandMotionType = (value: string) => expandedMotionTypes[value.toLowerCase()]

export const expandCourts = (courts: string[] | undefined = []) =>
  courts.flatMap((court) => {
    const courtData = courtParents.find(({ value }) => equalsIgnoreCase(court, value))
    const childrenCourts = courtData?.children?.filter((child) => !child.isJudgingOrgan)
    return childrenCourts?.length ? childrenCourts.map(({ value }) => value) : court.toUpperCase()
  })

export const findJournalState = (value: string) =>
  stateFilters.find((state) => equalsIgnoreCase(state.value, value))
